export default "__VITE_ASSET__BVTCV2gS__"